import Entity from '../entity';
export default class FlightClass extends Entity<string> {
  name: string;
  code: any;
  pricing: any;
}
